import { useState } from "react";
import { useNavigate } from "react-router-dom";

const PROVINCES: { name: string; cities: string[] }[] = [
  { name: "热门地区", cities: ["深圳", "长沙", "上海", "北京", "广州"] },
  { name: "广东", cities: ["深圳", "广州", "东莞", "佛山", "珠海", "惠州", "中山", "汕头"] },
  { name: "四川", cities: ["成都", "绵阳", "乐山", "南充", "德阳", "自贡"] },
  { name: "江苏", cities: ["南京", "苏州", "无锡", "常州", "南通", "扬州"] },
  { name: "上海", cities: ["上海"] },
  { name: "北京", cities: ["北京"] },
  { name: "河南", cities: ["郑州", "洛阳", "开封", "南阳", "信阳"] },
  { name: "湖北", cities: ["武汉", "宜昌", "襄阳", "荆州", "黄石"] },
  { name: "贵州", cities: ["贵阳", "遵义", "安顺", "毕节", "铜仁"] },
  { name: "重庆", cities: ["重庆"] },
  { name: "山东", cities: ["济南", "青岛", "烟台", "威海", "潍坊", "临沂"] },
  { name: "安徽", cities: ["合肥", "芜湖", "蚌埠", "淮南", "马鞍山"] },
  { name: "河北", cities: ["石家庄", "唐山", "保定", "廊坊", "秦皇岛"] },
  { name: "湖南", cities: ["长沙", "株洲", "湘潭", "衡阳", "郴州"] },
];

export default function CitySelectPage() {
  const navigate = useNavigate();
  const [currentCity] = useState("深圳");
  const [selectedCity, setSelectedCity] = useState("深圳");
  const [activeProvince, setActiveProvince] = useState(PROVINCES[0].name);
  const [searchQuery, setSearchQuery] = useState("");

  const currentProvince = PROVINCES.find((p) => p.name === activeProvince) || PROVINCES[0];

  const filteredProvinces = searchQuery
    ? PROVINCES.map((p) => ({
        ...p,
        cities: p.cities.filter((c) =>
          c.toLowerCase().includes(searchQuery.toLowerCase())
        ),
      })).filter((p) => p.cities.length > 0)
    : null;

  const handleSelectCity = (city: string) => {
    setSelectedCity(city);
    setTimeout(() => window.history.length > 1 ? navigate(-1) : navigate("/"), 300);
  };

  return (
    <div
      className="flex flex-col min-h-screen"
      style={{ background: "#F4F4F6", maxWidth: 480, margin: "0 auto" }}
    >
      {/* Search Header */}
      <div className="bg-white px-4 pt-4 pb-3 sticky top-0 z-40" style={{ borderBottom: "1px solid #F2F2F2" }}>
        <div className="flex items-center gap-3">
          <button type="button" onClick={() => window.history.length > 1 ? navigate(-1) : navigate("/")} className="w-8 h-8 flex items-center justify-center cursor-pointer">
            <i className="ri-arrow-left-line text-xl" style={{ color: "#1A1A1A" }} />
          </button>
          <div
            className="flex-1 flex items-center gap-2 rounded-full px-3 py-2"
            style={{ background: "#F5F5F5" }}
          >
            <i className="ri-search-line text-base" style={{ color: "#AAAAAA" }} />
            <input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="输入城市名称/拼音"
              className="flex-1 bg-transparent text-sm outline-none"
              style={{ color: "#333" }}
            />
            {searchQuery && (
              <button onClick={() => setSearchQuery("")} className="cursor-pointer">
                <i className="ri-close-circle-fill text-base" style={{ color: "#CCCCCC" }} />
              </button>
            )}
          </div>
        </div>
      </div>

      {searchQuery ? (
        /* Search results */
        <div className="flex-1 overflow-y-auto">
          {filteredProvinces && filteredProvinces.length > 0 ? (
            filteredProvinces.map((p) => (
              <div key={p.name}>
                <div className="px-4 py-2" style={{ background: "#F8F8F8" }}>
                  <span className="text-xs" style={{ color: "#AAAAAA" }}>{p.name}</span>
                </div>
                {p.cities.map((city) => (
                  <button
                    key={city}
                    onClick={() => handleSelectCity(city)}
                    className="w-full flex items-center justify-between px-4 py-3.5 cursor-pointer"
                    style={{ borderBottom: "1px solid #F5F5F5", background: "#fff" }}
                  >
                    <span className="text-sm" style={{ color: "#1A1A1A" }}>{city}</span>
                    {selectedCity === city && (
                      <i className="ri-check-line" style={{ color: "#FF7B22" }} />
                    )}
                  </button>
                ))}
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-20">
              <i className="ri-map-pin-line text-3xl mb-3" style={{ color: "#DDDDDD" }} />
              <p className="text-sm" style={{ color: "#AAAAAA" }}>未找到相关城市</p>
            </div>
          )}
        </div>
      ) : (
        /* Province + City two-column layout */
        <div className="flex flex-1 overflow-hidden">
          {/* Left: provinces */}
          <div
            className="overflow-y-auto flex-shrink-0"
            style={{ width: 100, background: "#F5F5F5", borderRight: "1px solid #EEEEEE" }}
          >
            {/* Current city first */}
            <div className="px-3 py-3" style={{ borderBottom: "1px solid #EEEEEE" }}>
              <div className="flex items-center gap-1.5 mb-1">
                <i className="ri-map-pin-2-fill text-sm" style={{ color: "#FF7B22" }} />
                <span className="text-xs" style={{ color: "#666" }}>{currentCity}</span>
                <button className="cursor-pointer">
                  <i className="ri-refresh-line text-xs" style={{ color: "#CCCCCC" }} />
                </button>
              </div>
            </div>
            {PROVINCES.map((p) => (
              <button
                key={p.name}
                onClick={() => setActiveProvince(p.name)}
                className="w-full px-3 py-3.5 text-sm text-left cursor-pointer transition-colors"
                style={{
                  background: activeProvince === p.name ? "#fff" : "transparent",
                  color: activeProvince === p.name ? "#FF7B22" : "#555",
                  fontWeight: activeProvince === p.name ? 600 : 400,
                  borderLeft: activeProvince === p.name ? "3px solid #FF7B22" : "3px solid transparent",
                }}
              >
                {p.name}
              </button>
            ))}
          </div>

          {/* Right: cities */}
          <div className="flex-1 overflow-y-auto bg-white">
            {currentProvince.cities.map((city) => (
              <button
                key={city}
                onClick={() => handleSelectCity(city)}
                className="w-full flex items-center justify-between px-4 py-4 cursor-pointer"
                style={{ borderBottom: "1px solid #F8F8F8" }}
              >
                <span
                  className="text-sm"
                  style={{
                    color: selectedCity === city ? "#FF7B22" : "#1A1A1A",
                    fontWeight: selectedCity === city ? 600 : 400,
                  }}
                >
                  {city}
                </span>
                {selectedCity === city && (
                  <i className="ri-check-line" style={{ color: "#FF7B22", fontSize: 18 }} />
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
